import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-loader',
  templateUrl: './common-loader.component.html',
  styleUrls: ['./common-loader.component.css']
})
export class CommonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
